<template>
  <ContentWrap>
    <el-form :model="form" label-width="120px" class="max-w-720px">
      <el-form-item label="统计时间窗" required>
        <el-date-picker
          v-model="range"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始(receiveTime)"
          end-placeholder="结束"
          :default-time="[new Date('1 00:00:00'), new Date('1 23:59:59')]"
          class="!w-420px"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" class="!w-420px" />
      </el-form-item>
      <el-form-item>
        <el-button :loading="previewLoading" @click="doPreview">预览分红池</el-button>
        <el-button
          v-hasPermi="['distribution:shareholder:settle:create']"
          type="primary"
          :loading="createLoading"
          @click="doCreate"
        >
          创建结算单（立即锁定）
        </el-button>
      </el-form-item>
    </el-form>

    <template v-if="preview">
      <el-alert
        v-if="preview.overflowCompressed"
        class="mb-12px"
        type="info"
        :closable="false"
        title="已发生溢出压缩：股东应发合计已按比例压入池金额"
      />
      <el-descriptions :column="4" border class="mb-16px">
        <el-descriptions-item label="池金额">￥{{ fenToYuan(preview.poolAmount || 0) }}</el-descriptions-item>
        <el-descriptions-item label="应发合计">￥{{ fenToYuan(preview.bonusAmount || 0) }}</el-descriptions-item>
        <el-descriptions-item label="订单数">{{ preview.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="股东数">{{ preview.partnerCount }}</el-descriptions-item>
      </el-descriptions>

      <el-divider content-position="left">股东预览</el-divider>
      <el-table :data="preview.partners || []" size="small" class="mb-16px">
        <el-table-column label="userId" prop="userId" width="100" />
        <el-table-column label="等级" prop="levelName" />
        <el-table-column label="等级%" prop="levelBonusRate" width="90" />
        <el-table-column label="压缩前" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.rawAmount || 0) }}</template>
        </el-table-column>
        <el-table-column label="系统额" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.systemAmount || 0) }}</template>
        </el-table-column>
      </el-table>

      <el-divider content-position="left">订单预览</el-divider>
      <el-table :data="preview.orders || []" size="small" max-height="360">
        <el-table-column label="订单ID" prop="orderId" width="100" />
        <el-table-column label="折后价" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.goodsDiscounted || 0) }}</template>
        </el-table-column>
        <el-table-column label="贡献额" width="110">
          <template #default="{ row }">￥{{ fenToYuan(row.contributeAmount || 0) }}</template>
        </el-table-column>
      </el-table>
    </template>
  </ContentWrap>
</template>

<script lang="ts" setup>
import { fenToYuan } from '@/utils'
import * as SettleApi from '@/api/mall/trade/shareholder/settle'

defineOptions({ name: 'TradeShareholderSettleBuild' })

const message = useMessage()
const range = ref<string[]>([])
const form = reactive({ remark: '' })
const previewLoading = ref(false)
const createLoading = ref(false)
const preview = ref<SettleApi.ShareholderSettlePreviewVO | null>(null)

const buildReq = () => {
  if (!range.value || range.value.length !== 2) {
    message.warning('请选择统计时间窗')
    throw new Error('no range')
  }
  return {
    startTime: range.value[0],
    endTime: range.value[1],
    remark: form.remark
  }
}

const doPreview = async () => {
  try {
    const req = buildReq()
    previewLoading.value = true
    preview.value = await SettleApi.previewShareholderSettle(req)
  } catch {
    /* tip already */
  } finally {
    previewLoading.value = false
  }
}

const doCreate = async () => {
  try {
    const req = buildReq()
    await message.confirm('创建后将立即锁定订单并禁售后，是否继续？')
    createLoading.value = true
    const id = await SettleApi.createShareholderSettle(req)
    message.success(`已创建结算单 #${id}，请到「待确认」查看`)
    preview.value = null
  } catch {
  } finally {
    createLoading.value = false
  }
}
</script>
